import { NewSms } from '../../pages';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { BulkSms } from '../../pages';
import { BulkSmsController, CustomerController } from '../../controllers';
import { appStore, customerStore, useStores, bulkSmsStore } from '../../stores';
import * as yup from 'yup';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { toJS } from 'mobx';

const NewSmsContainer = ({
    closeComposeSide,
    tags,
    setTags,
    customers,
    vendors,
    btnClicked,
    sendPayload,
    setSendPayload,
    showComposeSide,
    setBtnClicked,
    showScheduleMsgModal,
    setMsgView,
    setMsgFilterItem,
}) => {

    const [loading, setLoading] = useState(false);

    const selectAllCustomers = () => {
        const allCustomerNames = customers.map((x) => (x.fullname))
        setTags(tags.concat(allCustomerNames.filter((item) => tags.indexOf(item) < 0)))
    }
    const selectAllVendors = () => {
        const allVendorNames = vendors.map((x) => (x.name))
        setTags(tags.concat(allVendorNames.filter((item) => tags.indexOf(item) < 0)))
    }

    const removeAll = () => {
        setTags([]);
    }

    const selectAllProspects = () => {
        const allProspects = bulkSmsStore.allProspects.map((x) => (x.mobile))
        setTags(tags.concat(allProspects.filter((item) => tags.indexOf(item) < 0)))
    }

    const SmsValidation = () => {
        return yup.object({
            message: yup.string().required('Message is required'),
            mobile: yup.array().required('Customer phone number is required'),
        });
    };

    const onSubmit = async values => {
        const contacts = customers.concat(vendors);
        // const chosenCustomer = customers.filter(customer => tags.includes(customer.fullname))
        const chosenContacts = contacts.filter(contact => tags.includes({ a: contact.fullname || contact.name }))

        // const customerNames = chosenCustomer.map((x) => {
        //     return x.fullname
        // })
        // const contactNames = chosenContacts.map((x) => {
        //     return {
        //         a: x.mobile
        //     }
        // })

        const contactNumbers = chosenContacts.map((x) => {
            return x.mobile
        })

        // const numbersOnly = tags.filter((names) => !contactNames.includes(names))

        const mobileToSend = [...contactNumbers]


        if (btnClicked === "send" || btnClicked === "scheduleMessage") {
            if (tags.length === 0) {
                return MimaToastUtil.error({
                    message: "Please add customer number or type and select from saved customer names",
                });
            } else {
                setSendPayload({
                    mobile: mobileToSend,
                    message: values.message,
                })
            }
        }

        if (btnClicked === "saveDraft") {
            setLoading(true);
            let payload

            payload = {
                mobile: mobileToSend,
                message: values.message,
            }

            const { status, errorMessage } = await BulkSmsController.saveSmsDraft(payload);
            if (status === constant.Success) {
                setLoading(false);
                MimaToastUtil.success({
                    message: constant.Success,
                });
                closeComposeSide();
                setTags([]);
                setMsgView("Sent Messages");
                setMsgFilterItem("SENT");
            } else {
                setLoading(false);
                return MimaToastUtil.error({
                    message: errorMessage,
                });
            }
        }

    };



    return (
        <NewSms
            closeComposeSide={closeComposeSide}
            SmsValidation={SmsValidation}
            onSubmit={onSubmit}
            tags={tags}
            setTags={setTags}
            customers={customers}
            vendors={vendors}
            btnClicked={btnClicked}
            setBtnClicked={setBtnClicked}
            showScheduleMsgModal={showScheduleMsgModal}
            selectAllProspects={selectAllProspects}
            selectAllCustomers={selectAllCustomers}
            selectAllVendors={selectAllVendors}
            loading={loading}
            removeAll={removeAll}
        />
    )
}

export default NewSmsContainer